var _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _path5, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 86 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_30971_25893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 61.5,
    r: 25,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 61.5,
    r: 24.5,
    stroke: "white",
    strokeOpacity: 0.04
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9994 48.1785L28.3 51.5485L19.9888 59.8348L16.6882 56.544L24.9994 48.1785Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0099 53.1741L33.3105 56.5441L19.9888 69.8259L16.6882 66.5352L30.0099 53.1741Z",
    fill: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9783 58.1696L18.2789 61.5396L14.9783 64.8303L11.6777 61.5396L14.9783 58.1696Z",
    fill: "#F0B90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0207 58.1696L38.3213 61.5396L24.9996 74.8214L21.699 71.5307L35.0207 58.1696Z",
    fill: "#F0B90B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_30971_25893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 25.5,
    r: 25,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 25.5,
    r: 24.5,
    stroke: "white",
    strokeOpacity: 0.04
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30971_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5651 23.2653L43.0032 17.8294L48.4435 23.2697L51.606 20.105L43.0032 11.5L34.4004 20.1028L37.5651 23.2653Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 25.5011L32.1625 22.3364L35.3271 25.5011L32.1625 28.6636L29 25.5011Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5651 27.7348L43.0032 33.1729L48.4435 27.7325L51.6082 30.8928L43.0054 39.4978L34.4004 30.8994L37.5651 27.7348Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6729 25.5011L53.8353 22.3364L57 25.4989L53.8353 28.6658L50.6729 25.5011Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2123 25.4988L43.0033 22.2877L40.6304 24.6607L40.3562 24.9327L39.7944 25.4944L43.0033 28.7011L46.2123 25.5011V25.4988Z",
    fill: "#F3BA2F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_30971_25893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61.5,
    r: 25,
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61.5,
    r: 24.5,
    stroke: "white",
    strokeOpacity: 0.04
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_30971_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.58 64.8867C72.7101 72.3867 65.1134 76.9507 57.6124 75.0809C50.115 73.211 45.5506 65.6142 47.4209 58.1146C49.2899 50.6137 56.8862 46.0488 64.3849 47.9187C71.8854 49.7886 76.4494 57.3862 74.5796 64.8867H74.58Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.173 59.5055C67.4513 57.6426 66.0329 56.6412 64.0935 55.9731L64.7226 53.4496L63.1861 53.0668L62.5736 55.5238C62.1702 55.4232 61.7555 55.3282 61.3433 55.2342L61.9602 52.761L60.425 52.3782L59.7955 54.9008C59.4612 54.8247 59.1331 54.7494 58.8146 54.6702L58.8163 54.6624L56.698 54.1334L56.2893 55.774C56.2893 55.774 57.429 56.0352 57.405 56.0514C58.0271 56.2067 58.14 56.6184 58.1207 56.9448L57.4041 59.8196C57.447 59.8306 57.5025 59.8463 57.5638 59.8708L57.4019 59.8306L56.397 63.8577C56.3208 64.0467 56.1279 64.3302 55.693 64.2226C55.7083 64.2449 54.5765 63.9439 54.5765 63.9439L53.814 65.7027L55.8133 66.201C56.1852 66.2942 56.5497 66.3917 56.908 66.4836L56.2723 69.0364L57.8066 69.4192L58.4366 66.894C58.8553 67.0077 59.2622 67.1127 59.6603 67.2116L59.0329 69.7251L60.569 70.1079L61.2047 67.5603C63.824 68.056 65.794 67.8561 66.6222 65.4874C67.2903 63.5799 66.5894 62.4796 65.2113 61.7617C66.2149 61.5294 66.9709 60.8692 67.1726 59.5055H67.173ZM63.663 64.4269C63.1878 66.3344 59.9766 65.3037 58.9349 65.0447L59.7784 61.6632C60.8197 61.9231 64.1582 62.4376 63.6634 64.4269H63.663ZM64.1377 59.4779C63.7045 61.213 61.0314 60.3315 60.1638 60.1154L60.9286 57.0485C61.7962 57.2646 64.5892 57.668 64.1377 59.4779Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-6 -46H505V-48H-6V-46ZM528 -23V955H530V-23H528ZM505 978H-5.99999V980H505V978ZM-29 955V-23H-31V955H-29ZM-5.99999 978C-18.7025 978 -29 967.703 -29 955H-31C-31 968.807 -19.8071 980 -5.99999 980V978ZM528 955C528 967.703 517.703 978 505 978V980C518.807 980 530 968.807 530 955H528ZM505 -46C517.703 -46 528 -35.7025 528 -23H530C530 -36.8071 518.807 -48 505 -48V-46ZM-6 -48C-19.8071 -48 -31 -36.8071 -31 -23H-29C-29 -35.7025 -18.7025 -46 -6 -46V-48Z",
    fill: "white",
    fillOpacity: 0.04
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -49.5,
    y: -738.5,
    width: 1926,
    height: 2600,
    rx: 4.5,
    stroke: "#7B61FF",
    strokeDasharray: "10 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_30971_25893",
    x: -19,
    y: 17.5,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_30971_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_30971_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_30971_25893",
    x: -1,
    y: -18.5,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_30971_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_30971_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_30971_25893",
    x: 17,
    y: 17.5,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_30971_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_30971_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30971_25893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(29 11.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_30971_25893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(47 47.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLp);
export default __webpack_public_path__ + "static/media/lp.7fd57e3b.svg";
export { ForwardRef as ReactComponent };